import ContentMonedero from "../../components/monedero/ContentMonedero"
import HeaderHome from "../../components/headerHome/HeaderHome"
import './Monedero.css'
import { MiFooter } from "../../components/footer/MiFooter"
import { useState } from "react"
import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB"

const Monedero = () => {

    const [MenuLateralAux, setMenuLateralAux] = useState();
    
    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }

    return (<>
            <div className="headerMonitorCuidados">
                <HeaderHome chageMenuLateralAux={chageMenuLateralAux} />
            </div>
            <div className="bodyMonitorCuidados">
                <MenuLateralAB seleccionado={15} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
                <ContentMonedero />
            </div>
            <div className="footerMonitorCuidados">
                <MiFooter />
            </div>
        </>
    )
}

export default Monedero;